var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detailBox" }, [
    _c(
      "div",
      {
        staticClass: "content-box",
        staticStyle: { position: "absolute", "z-index": "400" },
        style: {
          left: _vm.form.x + 50 + "px",
          top: _vm.form.y - 111 + "px",
        },
      },
      [
        _c("div", { staticClass: "warn" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.town))]),
          _c(
            "ul",
            _vm._l(_vm.dataList, function (item, i) {
              return _c("li", { key: i, staticClass: "list-li" }, [
                _c("span", { staticClass: "point" }),
                _vm._v(" " + _vm._s(item.name) + "： "),
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
                _c("span", { staticClass: "unit" }, [
                  _vm._v("(" + _vm._s(item.unit) + ")"),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }